<template>
  <oa-modal :name="name">
    <template slot="header">
      <img class="modal-icon"
        src="@/assets/styles/frontend-library/images/message-dark-solid.svg"/>
      <span>Write a general update</span>
    </template>

    <template slot="body">

      <div class="form-group">
        <textarea id="message"
          rows="5"
          v-model="message"
          placeholder="Type your update or note here..." />
      </div>
    </template>

    <template slot="footer">
      <div>
        <button class="btn btn-green" :disabled="disableSubmit" @click="submitGeneralUpdateMsg()">
          Confirm
        </button>
        <button class="btn btn-small white-bg ut-ml-4"  @click="closeModal()">
          Cancel
        </button>
      </div>
    </template>

  </oa-modal>

</template>

<script>

import OaModal from '@/components/Modals/OaModal.vue';
import { mapState, mapMutations } from 'vuex';
// import { scroller } from 'vue-scrollto/src/scrollTo';
import StageUpdate from '@/mixins/StageUpdate';

export default {
  name: 'MessageLeadModal',
  components: {
    OaModal,
  },
  mixins: [
    StageUpdate,
  ],
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      notes: state => state.leadAgentMappingStore.notes,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
  },
  data() {
    return {
      name: 'message-lead-modal',
      disableSubmit: true,
      message: '',
    };
  },
  watch: {
    message() {
      this.disableSubmit = this.message === '';
    },
  },
  methods: {
    ...mapMutations('leadAgentMappingStore', [
      'setLeadAgentMapping',
      'pushNote',
    ]),
    closeModal() {
      this.resetFormView();
      this.$modal.hide(this.name);
    },
    resetFormView() {
      this.disableSubmit = true;
      this.message = '';
    },
    createCaseForGeneralUpdate() {
      const caseData = {
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
        leadstatus: 'General Update',
        comment: this.message,
      };
      return this.$apiServices.oa.lead.createCaseForLeadUpdate(caseData);
    },
    submitGeneralUpdateMsg() {
      if (!this.disableSubmit) {
        this.disableSubmit = true;
        this.saveGeneralUpdateMsg();
      }
    },
    saveGeneralUpdateMsg() {
      const data = {
        leadid: this.lead.id,
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        notetypeid: 3,
        note: this.message,
        userkey: this.isLamOwner ? this.lam.agentuserkey : (this.$route.params.uk || ''),
        userroleid: this.isLamOwner ? 2 : 11,
      };
      return this.$apiServices.oa.note.create(data)
        .then((noteData) => {
          if (noteData) {
            this.createCaseForGeneralUpdate();
            this.pushNote(noteData);
            const updatedLam = this.lam;
            updatedLam.agentlastupdatedate = noteData.createddate;
            this.setLeadAgentMapping(updatedLam);
            this.closeModal();
            // const firstScrollTo = scroller();
            // firstScrollTo('.general-update-section');
            this.$scrollTo('.general-update-section', 1000, { easing: 'ease', cancelable: false });
          }
        });
    },
  },
};


</script>

<style scoped lang="scss">


</style>
